export default __webpack_public_path__ + "static/media/ith-logo-pure.c3d08a2b.jpg";